import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import clsx from 'clsx';
import { AwardIcon } from '@/components/ui/SvgIcon/Static/SvgIconComponents';
import { Head } from '@/components/ui/Typography/Heading/Head';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
/**
 * セミナー：「注目のセミナー」の強調用コンポーネント
 * @param props
 * @constructor
 */
export const SeminarCliEmphasis = (props) => {
    const { className } = props;
    // transformの細かい設定がtailwindでできないのでcssで対応
    const beforeStyle = css `
    &::before {
      transform: perspective(44px) rotateX(12deg);
    }
  `;
    return (_jsx("div", Object.assign({ className: clsx('relative', 'z-0', 'after:block after:content-[""]', 'after:w-full after:h-[5px]', 'after:bg-gradient-to-r after:from-gradient-lite-blue-from after:to-gradient-lite-blue-to', className) }, { children: _jsx("div", Object.assign({ className: clsx('relative', 'flex items-center', 'p-[13px] px-[10px] pb-[5px]', 'w-[175px] h-[44px]', 'z-[1]', 'before:content-[""]', 'before:origin-bottom-left', 'before:absolute before:top-0 before:right-0 before:bottom-0 before:left-0 before:z-[-1]', 'before:bg-gradient-to-r before:from-gradient-lite-blue-from before:to-gradient-lite-blue-to'), css: beforeStyle }, { children: _jsxs(IconTextGroup, { children: [_jsx(AwardIcon, { size: 'lg' }), _jsx(Head, Object.assign({ color: 'white', size: 'xxs' }, { children: "\u6CE8\u76EE\u306E\u30BB\u30DF\u30CA\u30FC" }))] }) })) })));
};
